export default {
  usedEmail: null,
  isLoading: false,
  errorMessage: '',
  timerSeconds: null,
};
